import React from 'react';
import { GetMemberProgramQuery } from 'src/graphqlTypes/catalogServiceTypes';
import { Highlight } from '@src/components/ProgramDetails/ProgramHighlightsPanel/Highlight/Highlight';
import { getEffort } from '@src/utilities/programAttributeUtility';

interface Props {
	program: GetMemberProgramQuery['memberProgram'];
	loading: boolean;
}

export const EffortHighlight: React.FC<Props> = ({ program, loading }) => {
	const effort = getEffort(program);

	if (!effort) return null;

	return (
		<Highlight
			body={effort}
			label='Time each week'
			loading={loading}
			popoverContent='This is an estimate of the time you may spend on this program each week, but it depends on factors like your academic skills and individual course demands.'
		/>
	);
};
